import connection from '../../../images/brands/connection.svg';
import giroflex from '../../../images/brands/giroflex.svg';
import haag from '../../../images/brands/haag.svg';
import offecct from '../../../images/brands/offecct.svg';
import profim from '../../../images/brands/profim.svg';
import rh from '../../../images/brands/rh.svg';

export const resolveBrandLogo = (brand: string): string => {
  switch (brand.toLowerCase()) {
    case 'connection':
      return connection;
    case 'giroflex':
      return giroflex;
    case 'hag':
      return haag;
    case 'offecct':
      return offecct;
    case 'profim':
      return profim;
    case 'rh':
      return rh;
    default:
      return '';
  }
};
